import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

import Feedback from "../assets/Feedback.svg";
import { cursos } from "../constants/cursos";
import useForm from "../providers/useForm";

function TelaReclamacao() {
  const [valueCurso, setValueCurso] = useState("");
  const [valueReclamacao, setValueReclamacao] = useState("");
  const setObrigado = useForm((state) => state.setObrigado);

  return (
    <Box>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ px: 3 }}
      >
        <Box sx={{ textAlign: "center", px: 2 }}>
          <img
            alt="Feedback"
            src={Feedback}
            style={{
              marginTop: 20,
              display: "inline-block",
              maxWidth: "100%",
              width: 450,
            }}
          />
        </Box>
        <Box sx={{ maxWidth: 450 }}>
          <Typography
            align="center"
            color="inherit"
            sx={{
              color: "#D14343",
              fontSize: "24px",
            }}
            variant="h1"
          >
            O que você gostaria de comunicar ao diretor?
          </Typography>
        </Box>
        <Card sx={{ width: { xs: "100%", md: "70%", lg: "60%" } }}>
          <CardContent>
            <Box>
              <Typography sx={{ p: 1, mb: 1 }}>
                Descreva detalhadamente sua solicitação, dúvida, sugestão,
                elogio ou problema. Sua mensagem será encaminhada diretamente ao
                diretor e ao setor de Qualidade para análise e acompanhamento.
              </Typography>
            </Box>

            <FormControl sx={{ mb: 2 }} color="btn" fullWidth>
              <InputLabel htmlFor="grouped-select">
                Selecione o curso relacionado
              </InputLabel>
              <Select
                onChange={(event) => setValueCurso(event.target.value)}
                defaultValue=""
                id="grouped-select"
                label="Selecione o curso relacionado"
              >
                <MenuItem value="">
                  <em>Selecione uma opção</em>
                </MenuItem>
                {cursos.map((curso) => (
                  <MenuItem key={curso.id} value={curso.nome}>
                    {curso.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              onChange={(event) => setValueReclamacao(event.target.value)}
              color="btn"
              margin="dense"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              id="outlined-multiline-flexible"
              label="Mensagem"
              placeholder="Descreva aqui 🙂"
              multiline
              rows={4}
            />
            <Button
              disabled={!Boolean(valueReclamacao)}
              onClick={() => setObrigado(valueReclamacao, valueCurso)}
              fullWidth
              variant="contained"
              color="success"
              sx={{ mt: 2 }}
              endIcon={<LibraryAddCheckIcon />}
            >
              {" "}
              ENVIAR{" "}
            </Button>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}

export default TelaReclamacao;
